// API utility for authenticated requests
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
};

export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem('auth_token');

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...options.headers
  };

  // NOTE: deliberately NOT setting credentials:"include".
  // We use Bearer tokens for auth (not cookies), and credentials:include
  // triggers a DataCloneError ("object can not be cloned") on iOS Safari
  // when 3rd-party cookies (PostHog, gtag) are present.
  const response = await fetch(url, {
    ...options,
    headers,
  });

  return response;
};

/** Privacy: when displaying a participant's name to a worker (or in worker-facing surfaces), only show their first name. */
export const firstNameOnly = (fullName) => {
  if (!fullName) return "";
  return String(fullName).trim().split(/\s+/)[0];
};

// Backwards-compat alias used in some pages
export const getFirstNameOnly = firstNameOnly;
